import { render, staticRenderFns } from "./EditHousingDialog.vue?vue&type=template&id=6fbdff7b&scoped=true"
import script from "./EditHousingDialog.vue?vue&type=script&lang=js"
export * from "./EditHousingDialog.vue?vue&type=script&lang=js"
import style0 from "./EditHousingDialog.vue?vue&type=style&index=0&id=6fbdff7b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbdff7b",
  null
  
)

export default component.exports